<template>
  <div
    data-sb-regression="sb-column-sorting"
    :class="{
      [style.sortContainer]: true,
      [style.visibility]: props.sortOrder === undefined || props.sortOrder === 0,
    }"
  >
    <i
      aria-hidden="true"
      :class="{
        'sb-icon-long-arrow-up': true,
        [style.sortIconActive]: props.sortOrder === 1,
      }"
    />
    <i
      aria-hidden="true"
      :class="{
        'sb-icon-long-arrow-down': true,
        [style.sortIconActive]: props.sortOrder === -1
      }"
    />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import style from '@src/components/Table/next/components/style/columnSorting.module.scss';

const props = defineProps({
  /**
   * The sort order of the column. 1 for ascending, -1 for descending, 0 or undefined for no sort.
   */
  sortOrder: {
    type: Number,
    required: true,
  },
});
</script>
